import React from 'react';
import Item from './Item';

interface Props {
    items: object[];
    activeItem?: {
        id: number,
    };
    cssClasses: string;
    isLogin: boolean;
    isDesktop?: boolean;
    handleOnClick?: (item: object, isLogin: boolean) => void;
}

const Items: React.FC<Props> = ({
  items,
  activeItem,
  cssClasses,
  isLogin,
  isDesktop,
  handleOnClick,
}) => (
  <>
    {items?.map((item: any) => {
      return (
        <Item
          key={item.id}
          isDesktop={isDesktop}
          item={item}
          isLogin={isLogin}
          cssClasses={cssClasses}
          activeItem={activeItem}
          handleOnClick={handleOnClick}
        />
      );
    })}
  </>
);

export default Items;
